module.exports = __webpack_public_path__ + "img/shubham-dhage-_rZnChsIFuQ-unsplash.d274a6b2.jpg";